// extracted by mini-css-extract-plugin
export default {"root":"BaseMultilingualView_root__D9bS4","wrapper":"BaseMultilingualView_wrapper__0+sn7","head":"BaseMultilingualView_head__dvDGy","title":"BaseMultilingualView_title__6OpnW"};